module.exports = __webpack_public_path__ + "img/categories-6.acdb548f.jpg";